import React, { useContext } from 'react';
import { KatAlert, KatSpinner } from '@amzn/katal-react';
import { useViewCaseAggregatedQuery } from '../hooks/useViewCaseAggregatedQuery';
import { AuthContext } from 'src/state/providers/AuthProvider';
import { logger } from 'src/logger';
import { ViewCaseConstants } from 'src/constants/ProjectConstants';
import CaseDetailsProvider from './CaseDetailsProvider';
import { DDMAttributes } from 'src/integration/ddm/providers/DDMAttributesProvider';
import { DDMSchemaParser } from 'src/integration/ddm/DDMSchemaParser';
import { TranslationContext } from 'src/state/providers/TranslationProvider';

interface ICaseDetailsHydrater {
  caseId: string;
}
const CaseDetailsHydrater: React.FC<ICaseDetailsHydrater> = ({
  caseId,
  children,
}) => {
  const userContext = useContext(AuthContext);
  const bundles = useContext(TranslationContext);
  const { caseDetailsResponse, ddmSchemaResponse, error, isError, isLoading } =
    useViewCaseAggregatedQuery(caseId);

  if (isLoading) {
    return <KatSpinner data-testid="ViewCasePageSpinner" />;
  }

  if (isError) {
    logger.error(
      `Unable to fetch GetCaseDetails for userId: ${
        userContext.customerId
      }. Error is  ${JSON.stringify(error)}`,
    );

    const { messageBundle } = useContext(TranslationContext);

    return (
      <KatAlert
        data-testid="ViewCaseErrorBanner"
        description={`${messageBundle.getMessage(
          ViewCaseConstants.ERROR_LOADING_CASE_ID,
        )} ${caseId}`}
        variant="danger"
        persistent
      />
    );
  }
  const ddmAttributes: DDMAttributes = new DDMSchemaParser(
    ddmSchemaResponse!,
    bundles,
  ).getDDMAttributes();

  return (
    <CaseDetailsProvider
      caseId={caseId}
      caseDetailsResponse={caseDetailsResponse}
      ddmAttributes={ddmAttributes}
    >
      {children}
    </CaseDetailsProvider>
  );
};

export { CaseDetailsHydrater };
